import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { CollectionServer, deleteInArray, GET, IfElse, Model, QueryDetail, QueryOrder, updateInArray, useAuth, useNavigation, useUserContext } from 'fennec-ui'
import { errorCatch, POST } from 'fennec-ui'
import YImage from '../../../common/YImage';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { Alert } from 'antd';
import RezultatiPoMeropriyatiu from '../RezultatiPoMeropriyatiu';
import RezultatiPoMeropriyatiuVSerii from '../RezultatiPoMeropriyatiuVSerii';
// import { eventModelActions } from '../Event';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');
var _ = require('lodash');

export default function SeriiMeropriyatiya(props) {
    const [loading, setLoading] = useState(false);
    const { object, create } = props;
    const auth = useAuth();

    const filters = () => [
        {
            label: "Начало мероприятия",
            name: "meropriyatie.nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
        },
        // {
        //     label: "Мероприятие",
        //     name: "meropriyatie",
        //     type: "object",
        //     filterType: "group",
        //     mode: "dialog",
        //     modal: { width: "700px" },
        //     relation: {
        //         uiFilter: () => [
        //             {
        //                 label: "Дата начала",
        //                 name: "nachaloSorevnovaniya",
        //                 type: "date",
        //                 filterType: "range",
        //                 sort: true,
        //                 filter: true,

        //                 sorted: "ASC",
        //                 filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
        //             },
        //             {   // Тип мероприятия
        //                 label: "Тип мероприятия",
        //                 name: "tipMeropriyatiya",
        //                 filterType: "group",
        //                 display: (o) => o.opisanie,
        //                 sort: true,
        //                 filter: true
        //             },
        //             {   // Уровень мероприятия
        //                 label: "Уровень мероприятия",
        //                 name: "urovenMeropriyatiya",
        //                 filterType: "group",
        //                 display: (o) => o.opisanie,
        //                 sort: true,
        //                 filter: true
        //             },
        //             {   // Место проведения
        //                 label: "Место проведения",
        //                 name: "mestoProvedeniya",
        //                 filterType: "group",
        //                 display: (o) => o.name,
        //                 sort: true,
        //                 filter: true
        //             },
        //         ],
        //         displayString: (item) => {
        //             return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
        //         },
        //         display: (item) => {
        //             return (
        //                 <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

        //                     <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
        //                         <YImage item={item} width={32} hidePreview={true} />
        //                     </div>

        //                     <div style={{ flex: "auto", paddingLeft: "7px" }}>
        //                         <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
        //                             <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
        //                         </div>
        //                         <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
        //                             <span style={{
        //                                 marginRight: "5px",
        //                                 borderRadius: "5px",
        //                                 backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
        //                                 color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
        //                                 fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",
        //                                 fontSize: "12px",
        //                                 boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
        //                                 padding: "2px 4px"
        //                             }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
        //                             <span>{item?.mestoProvedeniya?.name}</span>
        //                         </div>
        //                     </div>
        //                 </div>
        //             )
        //         },
        //         reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
        //         type: "many-one",
        //     },
        //     queryFilter: [
        //         QueryDetail("combobox"),
        //         QueryOrder("nachaloSorevnovaniya", "DESC")
        //     ],
        //     sort: true,
        //     filter: true,
        // },
    ];

    return (
        <>
            <CollectionServer
                name={"MeropriyatieVSerii"}
                auth={auth}
                size="small"
                source={`/api/serii${(!create) ? "/com" : ""}/meropriyatiya/${object.ID}`}
                filters={filters}
                mode={"list"}
                render={(item) => {
                    let e = item.meropriyatie;

                    return (
                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", width: "100%", paddingRight: "18px" }}>
                            <div style={{ maxWidth: "78px" }}>
                                <div style={{ width: "78px", height: "78px", overflow: "hidden" }}>
                                    <YImage item={e} width={78} hidePreview={true} />
                                </div>
                                <div style={{ marginTop: "7px" }}>
                                    <div style={{
                                        backgroundColor: "#eaeaea",
                                        fontSize: "16px",
                                        fontWeight: "400",
                                        color: "black",
                                        borderRadius: "6px",
                                        textAlign: "center",
                                        padding: "0 7px",
                                        textAlign: "center",
                                    }}>
                                        <div style={{
                                            borderRadius: "5px",
                                            backgroundColor: "#f6214b",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            color: "white",
                                            margin: "0 -7px",
                                            boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
                                            padding: "3px 7px"
                                        }}>
                                            {dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
                                            {/* {true === sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) &&
                                                dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')
                                            }
                                            {true !== sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) &&
                                                <>
                                                    <div style={{ fontSize: "16px" }}>
                                                        {dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD')}
                                                        -
                                                        {dayjs(e.okonchanieSorevnovaniya).tz("Europe/Moscow").format('DD')}
                                                    </div>
                                                    <div style={{ fontSize: "14px" }}>
                                                        {dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('MMMM')} {dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('YYYY')}
                                                    </div>
                                                </>
                                            } */}
                                        </div>
                                        <div style={{
                                            fontSize: "10px",
                                            fontWeight: "400",
                                            padding: "0px"
                                        }}>
                                            {dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                            {/* {true === sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) && <>
                                                {dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                            </>}
                                            {true !== sameDay(e.nachaloSorevnovaniya, e.okonchanieSorevnovaniya) && <>
                                                {dayjs(e.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                                <span> - </span>
                                                {dayjs(e.okonchanieSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                                            </>} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                <a href={`/fed/event/${e.ID}`}>
                                <span style={{ fontWeight: "600" }}>{e.nazvanieMeropriyatiya}</span>
                                </a>
                                </div>
                                <div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>Уровень: </span><span>{e?.urovenMeropriyatiya?.opisanie}</span>
                                </div>
                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>Место проведения: </span>
                                    <span>{e?.mestoProvedeniya?.name}</span>
                                </div>
                                <div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>Этап: </span>
                                    <span>{item?.etap}</span>
                                </div>
                                <div key="q5" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                    <span>Коэффициент: </span>
                                    <span>{item?.koeffitsient}</span>
                                </div>
                                {(!item.podtverzhdenie) && <div style={{ paddingTop: "5px" }}>
                                    <Alert
                                        message="Не подтвеждено!"
                                        type="warning"
                                    />
                                </div>}
                            </div>
                        </div>
                    )
                }}
                collectionActions={() => [
                    ...IfElse(
                        (create == true), [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                let o = {
                                    seriyaID: object.ID,
                                    meropriyatieID: values.meropriyatieID,
                                    etap: values.etap,
                                    koeffitsient: values.koeffitsient,
                                }
                                POST(auth, `/api/serii/add-meropriyatie`, o,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Мероприятие",
                                    name: "meropriyatie",
                                    type: "object",
                                    mode: "dialog",
                                    modal: { width: "700px" },
                                    relation: {
                                        uiFilter: () => [
                                            {
                                                label: "Дата начала",
                                                name: "nachaloSorevnovaniya",
                                                type: "date",
                                                filterType: "range",
                                                sort: true,
                                                filter: true,

                                                sorted: "ASC",
                                                filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                            },
                                            {   // Тип мероприятия
                                                label: "Тип мероприятия",
                                                name: "tipMeropriyatiya",
                                                filterType: "group",
                                                display: (o) => o.opisanie,
                                                sort: true,
                                                filter: true
                                            },
                                            {   // Уровень мероприятия
                                                label: "Уровень мероприятия",
                                                name: "urovenMeropriyatiya",
                                                filterType: "group",
                                                display: (o) => o.opisanie,
                                                sort: true,
                                                filter: true
                                            },
                                            {   // Место проведения
                                                label: "Место проведения",
                                                name: "mestoProvedeniya",
                                                filterType: "group",
                                                display: (o) => o.name,
                                                sort: true,
                                                filter: true
                                            },
                                        ],
                                        displayString: (item) => {
                                            return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                        },
                                        display: (item) => {
                                            return (
                                                <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                                    <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                        <YImage item={item} width={32} hidePreview={true} />
                                                    </div>

                                                    <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                        <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                            <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                        </div>
                                                        <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                            <span style={{
                                                                marginRight: "5px",
                                                                borderRadius: "5px",

                                                                // backgroundColor: "#f6214b",
                                                                // color: "white",

                                                                backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                                color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                                fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                                                fontSize: "12px",


                                                                boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                                padding: "2px 4px"
                                                            }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                            <span>{item?.mestoProvedeniya?.name}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        },
                                        reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("combobox"),
                                        QueryOrder("nachaloSorevnovaniya", "DESC")
                                    ]
                                },
                                {
                                    label: "Этап",
                                    name: "etap",
                                    type: "int",
                                },
                                {
                                    label: "Коэффициент",
                                    name: "koeffitsient",
                                    type: "float",
                                },
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Добавить мероприятие",
                            modal: {
                                width: "600px",
                                title: "Добавить мероприятие",
                            }
                        }], []),
                ]}
                modelActions={(item) => [
                    ...IfElse(
                        (create == true), [
                        {
                            action: (values, unlock, close, { collection, setCollection }) => {
                                let o = {
                                    ID: item.ID,
                                    etap: values.etap,
                                    koeffitsient: values.koeffitsient,
                                }
                                POST(auth, `/api/serii/update-meropriyatie-v-serii`, o,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            object: item,
                            form: Model,
                            meta: [
                                {
                                    label: "Этап",
                                    name: "etap",
                                    type: "int",
                                },
                                {
                                    label: "Коэффициент",
                                    name: "koeffitsient",
                                    type: "float",
                                },
                            ],
                            options: {
                                initialValues: {},
                            },
                            title: "Изменить",
                            modal: {
                                width: "600px",
                                title: "Изменить",
                            }
                        }], []),
                    ...IfElse(
                        (create == true), [{
                            title: "Результаты мероприятия",
                            readonly: true,
                            noAntForm: true,
                            titles: {
                                subheader: <div style={{ paddingBottom: "15px" }}><div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
                                    {item?.meropriyatie?.nazvanieMeropriyatiya} - {dayjs(item?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item?.meropriyatie, "mestoProvedeniya.name")}
                                </div></div>
                            },
                            modal: {
                                width: "940px",
                            },
                            object: item?.meropriyatie,
                            form: RezultatiPoMeropriyatiu,
                            action: (values, unlock, close, { collection, setCollection }) => { },
                        }], []),
                        ...IfElse(
                            (create == true), [{
                                title: "Результаты мероприятия в серии",
                                readonly: true,
                                noAntForm: true,
                                titles: {
                                    subheader: <div style={{ paddingBottom: "15px" }}><div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
                                        {item?.meropriyatie?.nazvanieMeropriyatiya} - {dayjs(item?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item?.meropriyatie, "mestoProvedeniya.name")}
                                    </div></div>
                                },
                                modal: {
                                    width: "940px",
                                },
                                object: item,
                                form: RezultatiPoMeropriyatiuVSerii,
                                action: (values, unlock, close, { collection, setCollection }) => { },
                            },
                            {
                                type: 'divider',
                            }], []),
                    ...IfElse(
                        (create == true), [
                        {
                            danger: true,
                            title: "Удалить",
                            action: (values, unlock, close, { collection, setCollection }) => {
                                GET(auth, `/api/meropriyatie-v-serii/delete/${item.ID}`,
                                    () => setCollection(deleteInArray(collection, item)), errorCatch
                                );
                            },
                        }], []),
                    // ...eventModelActions(auth, navigation, user, dispatch, item, create, base, sourceKey, strickted, ctx)
                ]}
            />
        </>
    );
}
